<script setup lang="ts">
import { Drawer } from 'primevue'
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import ConnectWallet from './ConnectWallet.vue'
import { routerList } from './constant'

const router = useRouter()
const route = useRoute()
onMounted(() => {})
// 判断路由是否激活
function isActiveRoute(routeObj: any) {
  if (routeObj.path.includes(route.path)) {
    if (routeObj.query?.type) {
      if (routeObj.query.type !== route.query.type) {
        return false
      }
    }
    return true
  }
  return false
}
const visible = ref(false)
function toggleDrawer() {
  visible.value = !visible.value
}
</script>

<template>
  <div id="header" className="h-14">
    <div
      className="fixed z-[2000] top-0 left-0 right-0 h-14 bg-[#231F20] flex items-center justify-between px-4 border-b border-b-[#F3F6F81F]"
    >
      <div className="">
        <div className="flex items-center gap-2">
          <i class="pi pi-bars text-xl text-white" @click="toggleDrawer"></i>
          <img
            className="pr-2 h-6"
            src="@img/common/logo-white.png"
            alt="wrc-20_icon"
            @click="router.push('/')"
          />
        </div>
      </div>
      <div className="flex gap-2 items-center">
        <ConnectWallet />
      </div>

      <Drawer
        v-model:visible="visible"
        :modal="false"
        position="left"
        :pt="{ root: { style: { background: '#231F20', width: '185px', border: 'none' } } }"
        :show-close-icon="false"
      >
        <div class="pb-4 pt-10">
          <div class="pb-3">
            <div class="flex flex-col gap-3">
              <router-link
                v-for="item in routerList"
                :key="item.label"
                :to="item.path"
                class="h3 flex h-12 items-center justify-center rounded-[12px] font-medium"
                :class="isActiveRoute(item) ? 'bg-[#FAF8F6] text-[#171717]' : 'text-white'"
              >
                {{ item.label }}
              </router-link>
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  </div>
</template>

<style scoped lang="less"></style>
